export default __webpack_public_path__ + "static/media/cookies.e24e88d7.svg";